import { render, staticRenderFns } from "./PageEditProfileBasicInfo.vue?vue&type=template&id=5bacf71b&scoped=true&"
import script from "./PageEditProfileBasicInfo.vue?vue&type=script&lang=js&"
export * from "./PageEditProfileBasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./PageEditProfileBasicInfo.vue?vue&type=style&index=0&id=5bacf71b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bacf71b",
  null
  
)

export default component.exports